import api from './api';

const paymentService = {
  /**
   * Crear preferencia de pago en MercadoPago
   */
  async createPaymentPreference(items, payer, externalReference = null) {
    try {
      const response = await api.post('/payments/preference', {
        items: items.map(item => ({
          productId: item.productId || item.id,
          quantity: item.quantity
        })),
        payer: {
          name: payer.name || 'Cliente',
          email: payer.email || ''
        },
        externalReference: externalReference || `SALE-${Date.now()}`
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear preferencia de pago'
      };
    }
  },

  /**
   * Crear venta con pago pendiente de MercadoPago
   */
  async createSaleWithPayment(saleData, preferenceId) {
    try {
      const response = await api.post('/payments/sale', {
        ...saleData,
        preferenceId
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear venta con pago'
      };
    }
  },

  /**
   * Consultar estado de pago de una venta
   */
  async checkPaymentStatus(saleId) {
    try {
      const response = await api.get(`/payments/status/${saleId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al consultar estado de pago'
      };
    }
  },

  /**
   * Confirmar pago manualmente (para testing o pagos offline)
   */
  async confirmPayment(saleId) {
    try {
      const response = await api.post(`/payments/confirm/${saleId}`);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al confirmar pago'
      };
    }
  },

  /**
   * Proceso completo de pago con MercadoPago
   * 1. Crea la preferencia
   * 2. Crea la venta con estado pendiente
   * 3. Devuelve el link de pago
   */
  async processPaymentWithMercadoPago(cart, customerData, discount = 0, notes = '') {
    try {
      // 1. Crear preferencia de pago
      const externalReference = `SALE-${Date.now()}`;
      const preferenceResult = await this.createPaymentPreference(
        cart,
        {
          name: customerData.name,
          email: customerData.email
        },
        externalReference
      );

      if (!preferenceResult.success) {
        return preferenceResult;
      }

      // 2. Crear venta con estado pendiente
      const saleResult = await this.createSaleWithPayment({
        customerName: customerData.name,
        customerDocument: customerData.document,
        items: cart.map(item => ({
          productId: item.productId || item.id,
          quantity: item.quantity
        })),
        discount: parseFloat(discount) || 0,
        notes: notes || null
      }, preferenceResult.data.preferenceId);

      if (!saleResult.success) {
        return saleResult;
      }

      // 3. Devolver datos para redirigir
      return {
        success: true,
        data: {
          initPoint: preferenceResult.data.initPoint,
          sandboxInitPoint: preferenceResult.data.sandboxInitPoint,
          saleId: saleResult.data.id,
          saleNumber: saleResult.data.saleNumber,
          total: preferenceResult.data.total
        },
        message: 'Redirigiendo a MercadoPago...'
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Error al procesar pago con MercadoPago'
      };
    }
  }
};

export default paymentService;

